import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  isload = false;
  btndisable = false;
  addD: any = {};
  error_ = '';
  showPassword = false;

  constructor(
    public appservice: AppService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  get_Password() {
    return this.router.navigate(['/authentication/forgot-password']);
  }

  async login(form: any) {
    if (form.invalid || this.btndisable) {
      return;
    }

    this.btndisable = true;
    this.isload = true;
    this.error_ = '';

    try {
      const isLoggedIn = await this.appservice.loginWithCredentials(this.addD.Username, this.addD.Password);

      if (!isLoggedIn) {
        this.error_ = 'Invalid user name or password';
        this.toastr.error(this.error_, 'Error', { timeOut: 3000 });
        return;
      }

      const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
      const targetUrl = returnUrl || this.appservice.Lab_Home_Page || '/dashboard/default';

      await this.router.navigateByUrl(targetUrl, { replaceUrl: true });
    } catch (error) {
      console.log(error);
      this.error_ = 'Unable to sign in right now. Please try again.';
      this.toastr.error(this.error_, 'Error', { timeOut: 3000 });
    } finally {
      this.btndisable = false;
      this.isload = false;
    }
  }

  open() {
    window.open(this.appservice.Server_URL + 'Report/download_apk');
  }

  ngOnInit() {
  }
}
